var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(("background-image: url(" + (_vm.defaultImage()) + ");")),attrs:{"src":_vm.imageSrc,"alt":_vm.title},on:{"load":_vm.onLoad,"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }